import type { ReactNode } from "react";

/* ────── Featured Guide Icons (large, white on gradient) ────── */

function DnaClockIcon() {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 6Q12 12 20 6" />
      <path d="M4 14Q12 8 20 14" />
      <path d="M4 22Q12 28 20 22" />
      <path d="M4 30Q12 24 20 30" />
      <line x1="9" y1="10" x2="15" y2="10" opacity="0.5" />
      <line x1="9" y1="18" x2="15" y2="18" opacity="0.5" />
      <line x1="9" y1="26" x2="15" y2="26" opacity="0.5" />
      <circle cx="31" cy="16" r="7.5" />
      <line x1="31" y1="11.5" x2="31" y2="16" />
      <line x1="31" y1="16" x2="35" y2="18.5" />
    </svg>
  );
}

function FlameIcon() {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 4c0 8-10 12-10 22a10 10 0 0020 0c0-6-4-8-4-13s-3-6-6-9z" />
      <path d="M20 36c-3 0-5-2.5-5-6 0-4 5-7 5-11 0 4 5 7 5 11 0 3.5-2 6-5 6z" opacity="0.4" />
    </svg>
  );
}

function BrainPulseIcon() {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 7c-4-1-8 1-10 4s-3 7-1 11c1 3 3 5 5 6" />
      <path d="M20 7c4-1 8 1 10 4s3 7 1 11c-1 3-3 5-5 6" />
      <path d="M14 28v3M26 28v3" opacity="0.4" />
      <path d="M4 21h7l2.5-5 3.5 10 3.5-10 2.5 5h7" strokeWidth="1.8" />
    </svg>
  );
}

/* ────── Category Icons (small, white on solid color) ────── */

function GutIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 4v2c0 2-2 3-4 3s-4 1-4 3 2 3 4 3 4 1 4 3-2 3-4 3-4 1-4 3v1" />
    </svg>
  );
}

function InfinityIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 12c-2-3-4-5-6.5-5S1 9 1 12s1.5 5 4.5 5 4.5-2 6.5-5zm0 0c2 3 4 5 6.5 5s4.5-2 4.5-5-1.5-5-4.5-5-4.5 2-6.5 5z" />
    </svg>
  );
}

function MoleculeIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="6" r="2.5" />
      <circle cx="6" cy="18" r="2.5" />
      <circle cx="18" cy="18" r="2.5" />
      <line x1="12" y1="8.5" x2="7.5" y2="16" />
      <line x1="12" y1="8.5" x2="16.5" y2="16" />
      <line x1="8.5" y1="18" x2="15.5" y2="18" />
    </svg>
  );
}

function BrainIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2C9 2 6 4 6 8c-2 0-4 2-4 4s1 4 3 5c0 2 2 3 4 3h2" />
      <path d="M12 2c3 0 6 2 6 6 2 0 4 2 4 4s-1 4-3 5c0 2-2 3-4 3h-2" />
      <path d="M12 2v20" opacity="0.4" />
    </svg>
  );
}

function HeartPulseIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 6C10 2.5 4 2 4 8c0 4 8 10 8 10s8-6 8-10c0-6-6-5.5-8-2z" />
      <path d="M4 13h3l2-3 2 6 2-6 2 3h3" strokeWidth="1.3" />
    </svg>
  );
}

function ShieldPlusIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2L3 7v5c0 5.25 3.75 10.13 9 11.25C17.25 22.13 21 17.25 21 12V7L12 2z" />
      <line x1="12" y1="9" x2="12" y2="17" />
      <line x1="8" y1="13" x2="16" y2="13" />
    </svg>
  );
}

/* ────── Capability Icons (detail page, small on colored circles) ────── */

function CapClockIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="6" x2="12" y2="12" />
      <line x1="12" y1="12" x2="16.5" y2="14.5" />
    </svg>
  );
}

function CapFlaskIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 3h6M10 3v6.5L4 20h16L14 9.5V3" />
      <path d="M7.5 15h9" opacity="0.4" />
    </svg>
  );
}

function CapChartIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="12" width="4" height="8" rx="1" />
      <rect x="10" y="6" width="4" height="14" rx="1" />
      <rect x="17" y="9" width="4" height="11" rx="1" />
    </svg>
  );
}

function CapMoonIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12.79A9 9 0 0 1 11.21 3 7 7 0 1 0 21 12.79z" />
    </svg>
  );
}

/* ────── Icon Registry ────── */

export const MARKETPLACE_ICONS: Record<string, ReactNode> = {
  "dna-clock": <DnaClockIcon />,
  flame: <FlameIcon />,
  "brain-pulse": <BrainPulseIcon />,
  gut: <GutIcon />,
  infinity: <InfinityIcon />,
  molecule: <MoleculeIcon />,
  brain: <BrainIcon />,
  "heart-pulse": <HeartPulseIcon />,
  "shield-plus": <ShieldPlusIcon />,
  "cap-clock": <CapClockIcon />,
  "cap-flask": <CapFlaskIcon />,
  "cap-chart": <CapChartIcon />,
  "cap-moon": <CapMoonIcon />,
};
